import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot} from '@angular/router';
import { Observable } from 'rxjs';

import { Estado } from 'src/app/model/estado.model';
import { SolicitacaoCancelamentoGarantiaService } from 'src/app/shared/services/solicitacao-cancelamento-garantia.service';

@Injectable({ providedIn: 'root'})
export class EstadoSolicitacaoCancelamentoGarantiaResolver implements Resolve<Observable<Estado>> {
 
    constructor(private cancelamentoService: SolicitacaoCancelamentoGarantiaService) {
         
    }

    resolve(route: ActivatedRouteSnapshot
        ): Observable<Estado>  {

       return this.cancelamentoService.getEstadosSolicitacoesCancelamento();
    }
}
